import { CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'
import { RecommendedPricesQuotesTableComponent } from './quotes-table/table.component'
import { MessageService } from 'primeng/api'
import { SearchComponent } from 'src/app/shared/components/search/search.component'
import { LoadingIndicatorComponent } from 'src/app/shared/components/ui/loading-indicator/loading-indicator.component'
import { finalize } from 'rxjs'
import { RecommendedPricingService } from './services/recommended-pricing.service'
import { RecommendedPricesLiveQuotesTableComponent } from './live-quotes-table/table.component'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-recommended-prices',
  template: `
    <app-loading-indicator *ngIf="loading"></app-loading-indicator>

    <div>

      <div class="search-bar raisedbox pt-8">
        <app-search
          *ngIf="!loading"
          [searchValue]="searchValue"
          [options]="materialOptions"
          (onSearch)="handleSearch($event)"
          [selectedOption]="selectedMaterialOption"
          placeholder="Enter quote number"></app-search>
      </div>
    </div>

    <div>
      <app-recommended-prices-quotes-table
        *ngIf="!loading && quotesTableData"
        [tableData]="quotesTableData"
        [quoteId]="tableTitle"></app-recommended-prices-quotes-table>
    </div>

    <div *ngIf="!isDataAvailable && !loading">
      <div class="container text-center" style="height: 100%; width: 100%">
        <div class="row" style="height: 100%">
          <div class="col" style="margin-top: 10rem">
            <h2 class="color-primary mb-3">
              No data to display, please enter quote number to fetch data.
            </h2>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .search-bar {
        background: #fff;
        padding: 1.6rem 1rem 1.6rem 1.4rem;
        display: flex;
        align-items: baseline;
        justify-content: space-between;
      }
    `,
  ],
  standalone: true,
  imports: [
    CommonModule,
    RecommendedPricesQuotesTableComponent,
    SearchComponent,
    LoadingIndicatorComponent,
    RecommendedPricesLiveQuotesTableComponent,
  ],
})
export class RecommendedPricesComponent implements OnInit {
  isDataAvailable = false
  tableTitle = ''
  liveQuotesTableData!: any[]
  quotesTableData!: any[]
  loading = false
  materialOptions = [{ name: 'Quote Number', code: 'quoteId' }]
  selectedMaterialOption = { name: 'Quote Number', code: 'quoteId' }
  searchValue: string | undefined

  private messageService = inject(MessageService)
  private recommendedPricingService = inject(RecommendedPricingService)

  constructor(private route: ActivatedRoute){
    this.route.queryParams.subscribe((params) => {
      if (params.hasOwnProperty('quoteNumber')) {
        this.searchValue = params['quoteNumber'];
        this.handleSearch({
          searchValue: params['quoteNumber'],
        })
      }
    })
  }

  ngOnInit(): void {
    //this.getLiveQuotes()
  }

  handleSearch(query: any) {
    this.getQuoteLine(query.searchValue)
    this.tableTitle = query.searchValue
  }

  // handleQuoteClicked(quote: any) {
  //   this.tableTitle = quote.NAME
  //   this.getQuoteLine(quote.NAME)
  // }

  getQuoteLine(liveQuoteId: string) {
    this.loading = true
    this.quotesTableData = []

    this.isDataAvailable = true

    this.recommendedPricingService
      .getQuoteLine(liveQuoteId)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result: any) => {
          this.quotesTableData = result
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while processing your request.',
          })
        },
      })
  }

  getLiveQuotes() {
    this.loading = true
    this.liveQuotesTableData = []

    this.isDataAvailable = true

    this.recommendedPricingService
      .getLiveQuotes()
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (result: any) => {
          this.liveQuotesTableData = result.map((item: { CREATEDDATE: string | number | Date, SUBMITTEDDATE__C: string | number | Date }) => ({
            ...item,
            CREATEDDATE: new Date(item.CREATEDDATE),
            SUBMITTEDDATE__C: new Date(item.SUBMITTEDDATE__C),
          }));

          console.log(this.liveQuotesTableData)

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Data is received from server.',
          })
        },
        error: (e) => {
          console.log(e)
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'There is some error while processing your request.',
          })
        },
      })
  }
}
